function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.71666 7.78058C10.0811 8.25362 10.2595 8.83522 10.2595 9.53315C10.2595 10.5102 9.87951 11.2702 9.11954 11.7898C8.35958 12.3171 7.25066 12.5808 5.78502 12.5808H0V1.39844H5.46707C6.8319 1.39844 7.87879 1.6621 8.60773 2.18167C9.33668 2.70123 9.70115 3.41467 9.70115 4.30646C9.70115 4.84929 9.56932 5.33784 9.31341 5.7566C9.04975 6.18311 8.68528 6.51656 8.22 6.76471C8.84813 6.96633 9.35219 7.30754 9.71666 7.78058ZM2.57457 3.34487V5.98148H5.14913C5.78502 5.98148 6.27356 5.87292 6.59926 5.64803C6.93271 5.42314 7.09556 5.09744 7.09556 4.65542C7.09556 4.22116 6.93271 3.8877 6.59926 3.67057C6.26581 3.45344 5.78502 3.34487 5.14913 3.34487H2.57457ZM7.13434 10.2931C7.4833 10.0682 7.6539 9.72702 7.6539 9.25398C7.6539 8.33116 6.96373 7.86588 5.59115 7.86588H2.57457V10.6266H5.59115C6.27356 10.6343 6.78538 10.518 7.13434 10.2931Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5879 10.1836H14.3923L13.3997 12.5798H10.7476L15.7338 1.39746H18.2929L23.2947 12.5798H20.5805L19.5879 10.1836ZM18.7737 8.22162L16.9979 3.94101L15.222 8.22162H18.7737Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2189 3.50675H22.6362V1.39746H32.3839V3.50675H28.8012V12.5798H26.2189V3.50675Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2455 3.50772H31.3213V1.39844H42.4105V3.50772H38.8356V12.5808H36.2455V3.50772Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M43.8062 1.39746H46.3885V10.4705H51.9951V12.5798H43.8062V1.39746Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1079 10.5015V12.5798H53.4536V1.39746H61.9063V3.47573H56.0204V5.90296H61.2161V7.91143H56.0204V10.5015H62.1079Z",
  fill: "white"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M77.0203 1.40527H65.8535L71.4369 6.98869L77.0203 1.40527Z",
  fill: "url(#paint0_linear_2042_636)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M71.4369 6.98828L65.8535 12.5717H77.0203L71.4369 6.98828Z",
  fill: "url(#paint1_linear_2042_636)"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M84.232 0.94043C81.0216 0.94043 78.416 3.54602 78.416 6.75648C78.416 9.96694 81.0216 12.5725 84.232 12.5725C87.4425 12.5725 90.0481 9.96694 90.0481 6.75648C90.0481 3.54602 87.4425 0.94043 84.232 0.94043ZM84.232 10.1143C82.3787 10.1143 80.882 8.60986 80.882 6.76423C80.882 4.91861 82.3864 3.41419 84.232 3.41419C86.0777 3.41419 87.5821 4.91861 87.5821 6.76423C87.5821 8.60986 86.0854 10.1143 84.232 10.1143Z",
  fill: "white"
});
var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2042_636",
  x1: 77.187,
  y1: 6.5234,
  x2: 70.9459,
  y2: -4.8551,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C01B4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DC4B2B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2042_636",
  x1: 77.187,
  y1: 12.1064,
  x2: 70.9459,
  y2: 0.727909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C01B4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DC4B2B"
})));
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 13,
    viewBox: "0 0 91 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c3f631d242dbf375b22ee9d8e5ad755.svg";
export { ForwardRef as ReactComponent };